import { autoinject } from "aurelia-framework";
import { HttpService } from "../../services/http-service";
import { IDisplaySetting, IDisplaySettings } from "../../../typings/project";
import { Paths } from "../../paths";
import { Dropdown } from "bootstrap";
import { ToastService } from '../../services/toast-service';

@autoinject()
export class Management {
  displaySettings: IDisplaySettings = <IDisplaySettings>{};
  properties: Array<IDisplaySetting> = [];
  filters = [{ value: "", keys: ["name"] }];
  selectedPropertyList: keyof IDisplaySettings = "generalInformation";
  propertyLists: Array<string> = [];
  dropdownElement: HTMLElement;
  bsDropdown: Dropdown;

  constructor(
    private readonly httpService: HttpService,
    private readonly toast: ToastService
  ) {}
  
  async attached() {
    this.displaySettings = await this.httpService.get<IDisplaySettings>(
      Paths.getDisplaySettingsForAdmin
    );
    this.properties = this.displaySettings[this.selectedPropertyList];

    this.propertyLists = Object.keys(this.displaySettings);
    this.selectedPropertyList = "generalInformation";
    this.bsDropdown = new Dropdown(this.dropdownElement);
  }

  selectItem(selectedPropertyList: keyof IDisplaySettings) {
    this.properties = this.displaySettings[selectedPropertyList];
    this.selectedPropertyList = selectedPropertyList;
    
    if (this.bsDropdown) {
      setTimeout(() => {
        this.bsDropdown.hide();
      }, 0);
    }
  }

  async saveChanges() {
    this.displaySettings[this.selectedPropertyList] = this.properties;
    const parents = ['schoolManagement', 'additionalInformation', 'notes'];
    if (parents.find(x => x == this.selectedPropertyList)) {
      this.toggleParent(this.selectedPropertyList);
    }

    try {
      await this.httpService.post(Paths.updateDisplaySettings, this.displaySettings);
      this.toast.success("Settings updated.");
    } catch (err) {
      this.toast.error("Failed to save settings.");
    }
  }

  toggleParent(name: string) {
      this.displaySettings.generalInformation.find(
        x => x.displayName.toLocaleLowerCase() === name.toLocaleLowerCase()
      ).enabled = !this.properties.every(x => !x.enabled);
  }
}
